<template>
  <div class="running_bids">
    <div class="open-games91" @click="opengames91()">
      <p>
        {{$t('playGemsAndEarnDaily')}}
        <span class="material-icons">arrow_forward</span>
      </p>
    </div>
    <h3
      class="balance-text"
      v-if="runningBidData.userGemsBalance && (availableGemsBidList.length || allGemsBidProductsList.length)"
    >Gems Balance {{runningBidData.userGemsBalance}}</h3>
    <div class="new_bidding" v-if="availableGemsBidList.length">
      <h3 class="sub-heading" v-if="availableGemsBidList.length">{{$t('newBidding')}}</h3>
      <!-- <h3 class="sub-heading">{{$t('newBidding')}}</h3> -->
      <ul class="bidding_card" v-if="availableGemsBidList.length">
        <router-link
          :to="`/bidding-detail/${availableBid.biddingId}`"
          tag="li"
          class="card"
          v-for="(availableBid,index) in availableGemsBidList"
          :key="index"
        >
          <div class="img_wrapper">
            <img :src="availableBid.itemImage" v-if="availableBid.itemImage" />
            <img src="../../../assets/images/dummy.png" alt="profile-image" v-else />
          </div>
          <div class="prod-detail">
            <p class="prod-name">{{availableBid.itemName}}</p>
            <h5 class="bidding-price">
              <img src="../../../assets/images/detail/bidding-icon.svg" alt="profile-image" />
              <span>{{Math.round(availableBid.highestBidValue)}}</span>
              <img src="../../../assets/images/detail/gems.svg" alt class="mpoint" />
            </h5>
          </div>
          <p
            class="bidder-detail"
            v-if="availableBid.userName && availableBid.location"
          >{{$t('userIsWinning',{name:availableBid.userName, location:availableBid.location})}}</p>
          <p
            class="bidder-detail"
            v-if="availableBid.userName && !availableBid.location || availableBid.location === 'null'"
          >{{$t('userIsWinningWithoutLoc',{name:availableBid.userName})}}</p>
          <span class="new-icon">
            <img src="../../../assets/images/detail/ic_new.svg" alt="profile-image" />
          </span>
          <div class="time-trail">
            <p class="applied">
              {{$t('totalUserApplied')}} :
              <strong>{{availableBid.totalUser}}</strong>
            </p>
            <p class="applied">
              <span v-if="availableBid.biddingStatus === 'INACTIVE'">{{$t('bidStartTime')}} &nbsp;</span>
              <span v-if="availableBid.biddingStatus === 'STARTED'">{{$t('timeLeft')}} &nbsp;</span>
              <span v-if="availableBid.biddingStatus === 'CLOSED'">{{$t('biddingOver')}} &nbsp;</span>
              <span class="time" v-if="availableBid.biddingStatus !== 'CLOSED'">
                <Timer
                  :timing="getLiveTime(availableBid.biddingEndTimeMillis)"
                  @StopTime="timerStop"
                />
              </span>
            </p>
          </div>
        </router-link>
      </ul>
    </div>

    <infinite-loading @infinite="runningGemsBidProd" spinner="circles" class="visibilityHidden">
      <template slot="no-results">{{$t('noMoreRecord')}}</template>
    </infinite-loading>
    <div class="all_bidding" v-if="allGemsBidProductsList.length">
      <h3 class="sub-heading">{{$t('allBidding')}}</h3>
      <ul class="bidding_card" v-if="allGemsBidProductsList.length">
        <router-link
          :to="`/bidding-detail/${availableBid.biddingId}`"
          tag="li"
          class="card"
          v-for="(availableBid,index) in allGemsBidProductsList"
          :key="index"
        >
          <div class="img_wrapper">
            <img :src="availableBid.itemImage" v-if="availableBid.itemImage" />
            <img src="../../../assets/images/dummy.png" alt="profile-image" v-else />
          </div>
          <div class="prod-detail">
            <p class="prod-name" style="padding-right:0">{{availableBid.itemName}}</p>
            <h5 class="bidding-price">
              <img src="../../../assets/images/detail/bidding-icon.svg" alt="profile-image" />
              <span>{{Math.round(availableBid.highestBidValue)}}</span>
              <img src="../../../assets/images/detail/gems.svg" alt class="mpoint" />
            </h5>
          </div>
          <p
            class="bidder-detail"
            v-if="availableBid.userName && availableBid.location"
          >{{$t('userIsWinning',{name:availableBid.userName, location:availableBid.location})}}</p>
          <p
            class="bidder-detail"
            v-if="availableBid.userName && (!availableBid.location || availableBid.location === 'null')"
          >{{$t('userIsWinningWithoutLoc',{name:availableBid.userName})}}</p>
          <div class="time-trail">
            <p class="applied">
              {{$t('totalUserApplied')}} :
              <strong>{{availableBid.totalUser}}</strong>
            </p>
            <p class="applied">
              <span v-if="availableBid.biddingStatus === 'INACTIVE'">{{$t('bidStartTime')}} &nbsp;</span>
              <span v-if="availableBid.biddingStatus === 'STARTED'">{{$t('timeLeft')}} &nbsp;</span>
              <span v-if="availableBid.biddingStatus === 'CLOSED'">{{$t('biddingOver')}} &nbsp;</span>
              <span class="time" v-if="availableBid.biddingStatus !== 'CLOSED'">
                <Timer
                  :timing="getLiveTime(availableBid.biddingEndTimeMillis)"
                  @StopTime="timerStop"
                />
              </span>
            </p>
          </div>
        </router-link>
      </ul>
    </div>
     <infinite-loading @infinite="allGemsBidProducts" spinner="circles" class="visibilityHidden">
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
    <div class="cntntLoad" v-if="loading">
      <img src="../../../assets/images/loader.gif" alt="loader" />
    </div>
    <div
      v-if="noAllData && noStartingData && !availableGemsBidList.length && !allGemsBidProductsList.length"
      class="no_record"
    >
      <p>{{$t('noProductAreThere')}}</p>
    </div>
  </div>
</template>

<script>
import "../../../assets/css/bidding.scss";
import ApiCaller from "../../../utils/apicaller";
import constant from "../../../utils/constant";
import Timer from "../../../components/Common/TimeCount";

export default {
  name: "RunningGemsBids",
  components: {
    Timer
  },
  data() {
    return {
      availableGemsBidList: [],
      availableGemsBidIndex: 0,
      loading: false,
      noAllData: false,
      noStartingData: false,
      allGemsBidProductsList: [],
      allGemsBidProdIndex: 0,
      timeExpired: false,
      runningBidData: {}
    };
  },
  methods: {
    opengames91() {
      try {
        JSBridgePlugin.openMiniApp(
          149,
          "https://dev5.money91.com/#/",
          "Games91",
          "https://cdn.mall91.com/41dbc172-3ba9-4bda-b809-3570c37b40f6_original.png"
        );
      } catch (err) {
        console.log(err);
      }
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (!obj.timerShow) {
        this.timeExpired = true;
      }
    },
    runningGemsBidProd($state) {
      this.loading = true;
      ApiCaller(
        constant.GAMING_API_URL,
        "bidding/items/" + this.availableGemsBidIndex + "?biddingType=5",
        "get"
      )
        .then(data => {
          this.loading = false;
          this.runningBidData = data.data;
          if (data.data.biddingResponseDTOs.length) {
            this.availableGemsBidList.push(...data.data.biddingResponseDTOs);
            this.availableGemsBidIndex += 1;
            $state && $state.loaded();
          } else {
            this.noAllData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    allGemsBidProducts($state) {
      ApiCaller(
        constant.GAMING_API_URL,
        "bidding/items/" + this.allGemsBidProdIndex + "?biddingType=6",
        "get"
      )
        .then(data => {
          if (data.data.biddingResponseDTOs.length) {
            this.allGemsBidProductsList.push(...data.data.biddingResponseDTOs);
            this.allGemsBidProdIndex += 1;
            $state && $state.loaded();
          } else {
            this.noStartingData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.balance-text {
  font-size: 0.8em;
  color: #e84e16;
  font-weight: 600;
  position: absolute;
  right: 15px;
}
.open-games91 {
  font-size: 1em;
  font-weight: 500;
  text-align: center;
  background: #f4f6f8;
  padding: 5px;
  font-family: "Hind", sans-serif;
  color: #505050;
  margin: 0 -15px 15px;
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    text-shadow: 0 0 1px #0278ff;
    span {
      padding-left: 2px;
      font-size: 18px;
    }
  }
  .earn-money {
    .see-how {
      width: fit-content;
      border-bottom: 1px solid;
      margin-top: 8px;
    }
  }
}
</style>